module.exports = __webpack_public_path__ + "img/1219658038.a0ca2039.jpg";